import { useEffect, useState } from "react";

export default ({styles,programes=[],errors={},editFormData={
        programs: [],
        divisions: [],
        clinics: [],
    },
    updateFormData,
    isEdit=false
  })=>{

    const [formData, setFormData] = useState({
        programs: [],
        divisions: [],
        clinics: [],
    });
    const [editFormDataBack, setEditFormDataBack] = useState({
        programs: [],
        divisions: [],
        clinics: [],
    });
    const [isLoaded, setIsLoaded] = useState(false);
    const [divisions, setDivisions] = useState([]);
    const [clinics, setClinics] = useState([]);
    const handleMultiSelectChange = (name, value) => {
        setFormData(prev => {
            const currentValues = prev[name];
            const newValues = currentValues.includes(value)
            ? currentValues.filter(item => item !== value)
            : [...currentValues, value];
            
            return {
            ...prev,
            [name]: newValues
            };
        });

    };

    useEffect(()=>{
    setEditFormDataBack(editFormData);
     if(isEdit){
        setFormData((prev)=>{
            return {
                ...prev,
                programs:editFormData.programs
            }
        });
        setTimeout(()=>{
            setFormData((prev)=>{
                        return {
                            ...prev,
                            divisions:editFormData.divisions
                        }
                    });
        },500)
        setTimeout(()=>{
            setFormData((prev)=>{
                        return {
                            ...prev,
                            clinics:editFormData.clinics
                        }
                    });
        },1000)
     } else{ 
        // let oldDataDivision = [];
        // const _divisions = programes
        //       .flatMap(p => p.areas)
        //       .filter((p)=>{                 
        //           if(!oldDataDivision.includes(p.areaId)){ 
        //               oldDataDivision.push(p.areaId);
        //               return p;
        //           }
        //       });
        // oldDataDivision = [];
            
        // const _clinics = _divisions
        //       .flatMap(p => p.clinics)
        //       .filter((p)=>{                 
        //           if(!oldDataDivision.includes(p.clinicId)){ 
        //               oldDataDivision.push(p.clinicId);
        //               return p;
        //           }
        //       });

        // setFormData(prev => {          
        //       return {
        //       ...prev,
        //       programs: programes.map((p)=>p.programId),            
        //       };
        //   });

        // setTimeout(()=>{
        //   setFormData(prev => {          
        //       return {
        //       ...prev,
        //       divisions:_divisions.map((d)=>d.areaId)          
        //       };
        //   });
        // },500)

        // setTimeout(()=>{
        //   setFormData(prev => {          
        //       return {
        //       ...prev,
        //       clinics:_clinics.map((d)=>d.clinicId)          
        //       };
        //   });
        // },1000)  
     } 
     setIsLoaded(true);
    },[])
    
    useEffect(()=>{
        let oldData = [];
        const _divisions = programes
            .filter(p => formData.programs.includes(p.programId)) // filter selected
            .flatMap(p => p.areas)
            .filter((p)=>{                 
                if(!oldData.includes(p.areaId)){ 
                    oldData.push(p.areaId);
                    return p;
                }
            }).filter(i=>i.areaName!='');
           
        setDivisions(_divisions);
        if(editFormDataBack.divisions.length==0 && isLoaded){
          setTimeout(()=>{
              setFormData(prev => {          
                    return {
                    ...prev,
                    divisions:_divisions.map((d)=>d.areaId)          
                    };
                });
          },500)
         } 
    },[formData.programs]);

    useEffect(()=>{
        let oldData = [];
        const _clinics = divisions
            .filter(p => formData.divisions.includes(p.areaId)) // filter selected
            .flatMap(p => p.clinics)
            .filter((p)=>{                 
                if(!oldData.includes(p.clinicId)){ 
                    oldData.push(p.clinicId);
                    return p;
                }
            }).filter(i=>i.clinicName!='');
        setClinics(_clinics);

        if(editFormDataBack.clinics.length==0 && isLoaded){
          setTimeout(()=>{
            setFormData(prev => {          
                return {
                ...prev,
                clinics:_clinics.map((d)=>d.clinicId)          
                };
            });
          },500)  
        }
    },[formData.divisions]);

    useEffect(()=>{
        updateFormData(formData);
    },[formData])

    const handleSelectAll = (name, allOptions) => {
        let optionIds;
        
        if (name === 'programs') {
            optionIds = allOptions.map(option => option.programId);
        } else if (name === 'divisions') {
            optionIds = allOptions.map(option => option.areaId);
        } else if (name === 'clinics') {
            optionIds = allOptions.map(option => option.clinicId);
        }
        
        setFormData(prev => ({
            ...prev,
            [name]: prev[name].length === optionIds.length ? [] : [...optionIds]
        }));
    };


    return <div className={styles.formRow}>    
                <div className={styles.formGroup}>
                  <label>Select Programs</label>
                  <div className={styles.multiSelectContainer}>
                    <div className={styles.multiSelectHeader} 
                    onClick={() => handleSelectAll('programs', programes)}
                    
                    >
                      <span>{formData?.programs?.length === programes?.length ? 'Deselect All' : 'Select All'}</span>
                      <span className={styles.selectedCount}>({formData?.programs?.length}/{programes?.length})</span>
                    </div>
                    <div className={styles.multiSelectOptions}>
                      
                      {programes.map(option => (
                        <label key={option.programId} className={styles.multiSelectOption}>
                          <input
                            type="checkbox"
                            checked={formData?.programs?.includes(option.programId)}
                            onChange={() => handleMultiSelectChange('programs', option.programId)}
                          />
                          <span className={styles.checkmark}></span>
                          <span className={styles.optionLabel}>{option.programName}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                  {errors.programs && <span className={styles.errorMessage}>{errors.programs}</span>}
                </div>
    
                <div className={styles.formGroup}>
                  <label>Select Divisions</label>
                  <div className={styles.multiSelectContainer}>
                    <div className={styles.multiSelectHeader}
                     onClick={() => handleSelectAll('divisions', divisions)}
                     >
                      <span>{formData.divisions.length === divisions.length ? 'Deselect All' : 'Select All'}</span>
                      <span className={styles.selectedCount}>({formData.divisions.length}/{divisions.length})</span>
                    </div>
                    <div className={styles.multiSelectOptions}>
                      {divisions.map(option => (
                        <label key={`divisions_${option.areaId}`} className={styles.multiSelectOption}>
                            {/* {option.areaId} */}
                          <input
                            type="checkbox"
                            checked={formData.divisions.includes(option.areaId)}
                            onChange={() => handleMultiSelectChange('divisions', option.areaId)}
                          />
                          <span className={styles.checkmark}></span>
                          <span>{option.areaName}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                  {errors.divisions && <span className={styles.errorMessage}>{errors.divisions}</span>}
                </div>
    
                <div className={styles.formGroup}>
                  <label>Select Clinics</label>
                  <div className={styles.multiSelectContainer}>
                    <div className={styles.multiSelectHeader}
                     onClick={() => handleSelectAll('clinics', clinics)}
                        >
                      <span>{formData.clinics.length === clinics.length ? 'Deselect All' : 'Select All'}</span>
                      <span className={styles.selectedCount}>({formData.clinics.length}/{clinics.length})</span>
                    </div>
                    <div className={styles.multiSelectOptions}>
                      {clinics.map(option => (
                        <label key={option.clinicId} className={styles.multiSelectOption}>
                          <input
                            type="checkbox"
                            checked={formData.clinics.includes(option.clinicId)}
                            onChange={() => handleMultiSelectChange('clinics', option.clinicId)}
                          />
                          <span className={styles.checkmark}></span>
                          <span>{option.clinicName}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                  {errors.clinics && <span className={styles.errorMessage}>{errors.clinics}</span>}
                </div>
              </div>
}